// extracted by mini-css-extract-plugin
module.exports = {"container":"electionYearResult_container__2tIB7"};